import React from 'react';
import {Styles} from '../../../../config/design/styles';
import FileManagerDialog from "./FileManagerDialog";
import {defaultVariables} from "../../../../config";
import {withStyles} from "@mui/styles";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import {Card, CardContent, IconButton, Typography} from "@mui/material";
import {AddBoxRounded, Cancel, DescriptionTwoTone} from "@mui/icons-material";
import {translateKey} from "../../../../config/values";

class SingleFileChooser extends React.Component {
    classes = this.props.classes;
    state={

        FileManagerPending: false,
        file: null,
    }
    componentDidMount(){
        this.loadData()
    }
    async loadData(){
        await this.setState({
            file:this.props.initial
        })
        await this.fileChanges();
    }
    toggleOperation= () => {
        this.setState({
            FileManagerPending:!this.state.FileManagerPending,
        })
    }

    setData = async (data) => {
        await this.setState({
            file:data
        })

        await this.fileChanges();
        await this.toggleOperation();
    }
    async removeDataSheet(){
        await this.setState({
            file: null
        });
        this.fileChanges();
    }
    async fileChanges(){
        let {file} = this.state;
        await this.props.onChange(file)
    }
    render(){
        let {FileManagerPending,file} = this.state;
        let{title,required,disabled,print,type} = this.props;

        return(
            <React.Fragment>
                <Grid container spacing={2} direction="row" alignItems="center"  style={{minHeight:80}} >
                    <Grid item size={12} className="mt-20">
                        <Typography >{title} {!!required &&
                            <span className={this.classes.requiredSign}>*</span>}</Typography>
                    </Grid>
                    {
                        !!file &&
                        <Grid item size={12} style={{marginBottom:15,textAlign:'center'}}>
                            <Card style={{position:"relative"}}>
                                <CardContent>
                                    <a  rel="noopener noreferrer"  className={this.classes.primaryLink} target="_blank" href={`${defaultVariables.uploads}/FileManager/${file.name}.${file.extension}`}>
                                        {
                                            file.type === 'image' ? <img src={`${defaultVariables.uploads}/FileManager/${file.name}.${file.extension}`} className="fileChooser-image"/> : null
                                        }
                                        {
                                            file.type === 'document' ? <DescriptionTwoTone fontSize="large" /> : null
                                        }
                                    </a>

                                    <br />
                                    <Typography>
                                        <a  rel="noopener noreferrer"  className={this.classes.primaryLink} target="_blank" href={`${defaultVariables.uploads}/FileManager/${file.name}.${file.extension}`}>
                                            {file.name}
                                        </a>
                                        {
                                            !print &&
                                            <IconButton style={{position:"absolute",top:5,right:5}} size="small" onClick={() => this.removeDataSheet()} aria-label={translateKey('removeImage')}>
                                                <Cancel />
                                            </IconButton>
                                        }

                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    }
                    {
                        !disabled && !file &&
                        <Grid item size={12}>
                            <Button
                                startIcon={<AddBoxRounded />}
                                color="secondary"
                                variant="outlined"
                                size="small"
                                onClick={this.toggleOperation.bind(this)}
                            >
                                {translateKey('chooseMedia')}
                            </Button>
                        </Grid>

                    }

                </Grid>

                {
                    FileManagerPending ? <FileManagerDialog fileType={!!type ? type : 'all'}  selection cancleOperation={this.toggleOperation} setData={this.setData}/> : null
                }
            </React.Fragment>
        )

    }
}
export default withStyles(Styles)(SingleFileChooser);